<template>
   <form class="form-login" @submit.prevent="submit">

           <div class="lines">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div> 
            
        <div class="row">
            <div class="col-md-12 text-center mb-4">
                <img alt="logo" style="width: 58px; hight: 58px" :src="settings.image_path" class="theme-logo">
            </div>

            <div class="col-md-12">
              <div class="alert alert-danger" v-if="error ==1">{{errorShow}}</div>
                <label for="inputEmail" class="">رقم الجوال</label>                
                <input type="text" id="inputEmail" class="form-control mb-4" placeholder="رقم الجوال" v-model="cred.mobile" required >                
                <label for="inputPassword" class="">كلمة المرور</label>                
                <input type="password" id="inputPassword" class="form-control mb-5" placeholder="كلمة المرور" v-model="cred.password" required>                
                <div class="checkbox d-flex justify-content-between mb-4 mt-3">
                    <div class="custom-control custom-checkbox mr-3">
                        <input type="checkbox" class="custom-control-input" v-model="cred.remember_me" id="customCheck1">
                        <label class="custom-control-label"  for="customCheck1">تذكرنى</label>
                    </div>
                    <!-- <div class="forgot-pass">
                        <a href="user_pass_recovery_1.html">Forgot Password?</a>
                    </div> -->
                </div>                
                <button class="btn btn-lg btn-gradient-danger btn-block btn-rounded mb-4 mt-5" v-if="!isRequested" type="submit">تسجيل الدخول</button>
            </div>
        </div>
    </form>
</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
  data() {
    return {
      settings: {},
      cred: {
        mobile: '',
        password: '',
        remember_me: true
      },
      errors: {},
      errorShow: '',
      authError: '',
      error: 0,
      isRequested: false,
    }
  },
  created(){
    let isRequested = localStorage.getItem('parent_register');
    if(isRequested){
        this.sweetAlert('تمت التسجيل بنجاح');
        localStorage.removeItem('parent_register');
    }
    this.getSettings();
  },
  methods: {
     sweetAlert(message = 'please enter any message', type = 'success') {
      this.$root.swal.fire({
        icon: type,
        text: message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      });
     },
    getSettings(){

      this.$baseApi.get('/parent-settings').then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          this.settings = response.data.data;
        }
      }).catch((error) => {
        
      });

    },
    isAppleDevice() {
      return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
    },

localStorageAvailable() {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
},

storeData(key, value) {
  let dataToStore;

  // Check if value is an object (JSON) or a simple string
  if (typeof value === 'object' && value !== null) {
    dataToStore = JSON.stringify(value); // Convert JSON object to string
  } else {
    dataToStore = value; // If it's already a string, store it as is
  }

  if (this.isAppleDevice() && !this.localStorageAvailable()) {
    // Store the data in cookies for Apple devices
    document.cookie = `${key}=${dataToStore}; path=/`;
  } else {
    // Store the data in localStorage for other devices
    localStorage.setItem(key, dataToStore);
  }
},

retrieveData(key) {
  let data;

  if (this.isAppleDevice() && !this.localStorageAvailable()) {
    // Retrieve data from cookies
    const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
    data = match ? match[2] : null;
  } else {
    // Retrieve data from localStorage
    data = localStorage.getItem(key);
  }

  try {
    // Try to parse the data as JSON
    return JSON.parse(data);
  } catch (e) {
    // If parsing fails, return the data as a string
    return data;
  }
},

    submit() {
      this.isRequested = true;
         this.error = 0;
      this.$baseApi.post('/parent-login', this.cred).then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          store.dispatch('SET_AUTH_USER', res.user);
          let token = {
            value: res.access_token,
            type: res.token_type,
            expires_at: res.expires_in
          };
          store.dispatch('SET_TOKEN', token);
          store.dispatch('SET_AUTH', true);
          store.dispatch('SET_PERMISSIONS', res.permissions);
          // this.storeData('token', token.value);
          // this.storeData("auth", JSON.stringify(res.user));
          this.$cookies.set('token', token.value);
        this.$cookies.set('role', res.user.role);
        this.$cookies.set('user', {name: res.user.name, email: res.user.email, role: res.user.role});
          location.reload();
          router.push('/dashboard');
          this.isRequested = false;
        }
      }).catch((error) => {
        this.errorShow = error.response.data.errors[0];
         this.error = 1;
          this.isRequested = false;
        
      })

    }
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.errors))
    }
  },
};
</script>
